import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'
import { globalHistory } from "@reach/router"

if (!("XMLHttpRequest" in global)) {
    global.XMLHttpRequest = undefined;
    global.XDomainRequest = undefined;
}
    
const varinstrumentationKey = process.env.APPINSIGHTS_KEY || '022ee653-0b88-4aac-b148-8dd20dbe669f';
const var_local = process.env.LOCAL_VAR;  
if(var_local == 1){varinstrumentationKey = 'NOKEY123456'; }  
   
const reactPlugin = new ReactPlugin();
const ai = new ApplicationInsights({
    config: { 
        instrumentationKey: varinstrumentationKey, 
        extensions: [reactPlugin], 
        extensionConfig: {
            [reactPlugin.identifier]: { history: globalHistory }
        }
    }
})   
ai.loadAppInsights() 
console.log('loadAppInsightsA');    
/* console.log('loadAppInsights VAR - '+ varinstrumentationKey +'////'+ var_local); 
console.log('loadAppInsights - '+ process.env.APPINSIGHTS_KEY);  */
export default (Component) => withAITracking(reactPlugin, Component)
export const appInsights = ai.appInsights
  
 /*   "@microsoft/applicationinsights-web": "^2.5.3", */
/*npm i @microsoft/applicationinsights-react-js */
/* var telemetryInitializer = (envelope) => { //abc123
    envelope.data.someField = 'This item passed through my telemetry initializer';
  };
  appInsights.addTelemetryInitializer(telemetryInitializer);
  appInsights.trackTrace({message: 'This message will use a telemetry initializer'});
  
  appInsights.addTelemetryInitializer(() => false); // Nothing is sent after this is executed
  appInsights.trackTrace({message: 'this message will not be sent'}); // Not sent */